import * as React from 'react';

import {GaItemListName} from '../../../client/ga/ga-ecommerce.functions';
import {Item, OrderableItem} from '../item.class';
import {ItemSpinner} from '../item-spinner/ItemSpinner';
import {User} from '../../users/user.class';
import Button from '../../ui/Buttons/Button';

interface AlternateProductsProps {
    alternateProducts: OrderableItem[];
    item: Item;
    maxSlides?: number;
    user: User;
}

export const AlternateProducts = ({alternateProducts, item, maxSlides = 7, user}: AlternateProductsProps) => {
    const categoryBreadcrumb = item?.breadcrumbs[item.breadcrumbs.length - 1];
    const componentName = `AlternateProducts`;
    const gaItemListName: GaItemListName = `alternate_products`;

    /**
     * Template
     */
    return (
        <div data-e2e="alternate-products-component">
            <div className="tw-mb-3">Alternate products displayed may not be identical in style or function to original selection.</div>

            {alternateProducts?.length > 0 ? (
                <div className="tw-border tw-border-t-4 tw-p-4 tw-mb-3">
                    <ItemSpinner
                        componentName={componentName}
                        gaItemListName={gaItemListName}
                        label="Alternate Products"
                        loaded
                        maxSlides={maxSlides}
                        orderableItems={alternateProducts}
                        useAddToOrderModal
                        user={user}
                    />
                </div>
            ) : (
                <div className="tw-border tw-border-t-4 tw-p-4 tw-mb-3">
                    <div className="tw-text-gray-400 tw-mb-3">No alternate products are currently available</div>

                    <div>See more options:</div>
                    <div className="tw-mb-3">
                        <Button
                            onClick={() => location.assign(`/browse/${categoryBreadcrumb?.categoryPath || ''}`)}
                            size="lg"
                            variant="secondary"
                        >
                            Shop All {categoryBreadcrumb?.name || `Products`}
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
};
